import React from 'react';
import Footer from '../components/Footer';
import colline from '../assets/colline2.png';
import {theme} from '../utils/theme';
import trees from '../assets/trees.png';
import Box from '../components/Box';
import Wizard from '../components/Wizard';
import { useMediaQuery } from 'react-responsive';

const MainContent = () => {
    const isNotMobile = useMediaQuery({ query: '(min-width: 768px)' });
    return (
        <div style={{...styles.container,
            background: `top / contain no-repeat url(${colline}), linear-gradient(to bottom, ${theme.secondary},${theme.secondary})`,
        }}>
            <div style={{height: 200}}/>
            <div style={styles.formContainer}>
                {isNotMobile && <img src={trees} alt='alberi' style={styles.trees}/>}
                <Box style={{...styles.formBox, margin: isNotMobile ? 0 : '0 10px'}}>
                    <Wizard/>
                </Box>
                {isNotMobile && <img src={trees} alt='alberi' style={{...styles.trees, visibility: 'hidden'}}/>}
            </div>
        </div>
    );
}

export default function FormPage() {
    return (
        <div>
            <Footer style={{height: 150}}/>
            <MainContent/>
            {/* <img src={colline} alt="colline" style={styles.colline}/> */}
        </div>
    );
}
const styles = {
    container:{
        paddingBottom: 100,
        minHeight: '100vh',
        // height: '100vh',
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'contain',
        // backgroundPosition: 'top',
        // backgroundColor: 'linear-gradient(to bottom, rgba(55,146,62,255),rgba(129,205,83,255))',
    },
    colline: {
        width: '100%',
        height: 'auto',
    },
    trees: {
        width: '15%',
        maxWidth: '100px',
        height: 'fit-content',
        // resizeMode: 'contain',
        position: 'relative',
        left: 0,
        top: 0,
    },
    formContainer:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        // height: '100%',
        width: '100%',
        gap: 10,
    },
    formBox:{
        flex: 1,
        backgroundColor: '#FFFFFFE5',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // minWidth: 400,
    }
}